module.exports = __webpack_public_path__ + "static/media/train13-2.a0d7fe29.png";